import { Send } from "lucide-react";
import { Edit3 } from "lucide-react";

const MobileStickyBar = ({ onOpenModal, onOpenSketch }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] md:hidden bg-ink/95 border-t border-white/10 mobile-sticky-bar">
      <div className="flex gap-3 p-4">
        <button
          onClick={onOpenSketch}
          className="flex-1 bg-white/10 text-on-dark border border-white/20 rounded-full py-3 text-sm font-medium"
          data-testid="mobile-secondary-cta"
        >
          Kérdésem van
        </button>
        <button
          onClick={onOpenModal}
          className="flex-1 bg-gradient-to-r from-primary to-accent text-white rounded-full py-3 text-sm font-semibold shadow-glow"
          data-testid="mobile-primary-cta"
        >
          Gyors ajánlat
        </button>
      </div>
    </div>
  );
};

export default MobileStickyBar;
